import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/HoursMainPicture.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import Features from "components/features/PrivacyPolicyFeature.js";


export default () => (
    <Features />
);
